import { Impulse } from "~/tools/impulse";

/**
 * TODO STAC-19552: inject the maintenance flag to the request context
 *
 * The request function does not have access to react context
 * but it needs a way to indicate 503 responses to the user
 */
export const isMaintenanceBoundaryActive = Impulse(false);
